import type { CSSProperties } from 'react'

interface MaskedIconProps {
  src: string
  size?: number | string
  className?: string
  color?: string
  style?: CSSProperties
}

export default function MaskedIcon({
  src,
  size = 24,
  className,
  color,
  style,
}: MaskedIconProps) {
  if (color) {
    return (
      <span
        aria-hidden
        className={className}
        style={{
          display: 'inline-block',
          width: size,
          height: size,
          flexShrink: 0,
          backgroundColor: color,
          WebkitMaskImage: `url("${src}")`,
          WebkitMaskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskImage: `url("${src}")`,
          maskSize: 'contain',
          maskRepeat: 'no-repeat',
          maskPosition: 'center',
          ...style,
        }}
      />
    )
  }

  return (
    <img
      src={src}
      alt=""
      width={typeof size === 'number' ? size : undefined}
      height={typeof size === 'number' ? size : undefined}
      className={className}
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        ...style,
      }}
    />
  )
}
